import { render, staticRenderFns } from "./AttendeesTable.vue?vue&type=template&id=b6b9ede4&"
import script from "./AttendeesTable.vue?vue&type=script&lang=js&"
export * from "./AttendeesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports